export const getStatusLabel = (status) => {
  const labels = {
    published: 'Publié',
    draft: 'Brouillon',
    pending_review: 'En révision',
    scheduled: 'Programmé'
  };
  return labels[status] || status;
};

export const canShareRelease = (status) => {
  return status === 'published' || status === 'scheduled';
};

export const emptyReleaseForm = {
  id: null,
  title: '',
  slug: '',
  description: '',
  price_ariary: '',
  status: 'published',
  publication_date: new Date().toISOString(),
  cover_url: '',
  cover_storage_provider: '',
  cover_storage_key: '',
  cover_file: null,
  cover_preview: '',
  type: 'album', // 'single' or 'album'
  is_free: false,
  tracks: []
};
